<template>
  <div :class="{ container: container }">
    <div class="card">
      <div
        :class="[noHeaderPadding ? `p-0` : null, isSmall ? 'py-2' : ' text-big']"
        class="card-header"
      >
        <slot v-if="!title" name="header" />
        <span v-else>
          <template
            v-if="
              back &&
              (typeof back === 'string' ||
                (typeof back === 'boolean' && $router.options.history.state.back))
            "
          >
            <nuxt-link
              :to="typeof back === 'string' ? back : $router.options.history.state.back"
              class="no-link-text"
            >
              <arrow-left-circle-outline-icon title="Back" />
            </nuxt-link>
          </template>
          {{ noTranslate ? title : tr(title) }}
        </span>
      </div>
      <div :class="noPadding ? `p-0` : null" class="card-body">
        <loading-indicator v-if="loading" />
        <slot v-else />
      </div>
    </div>
  </div>
</template>

<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    name: 'CardContainer',
    props: {
      title: { type: String, default: '' },
      container: { type: Boolean, default: true },
      back: { type: [String, Boolean], default: null },
      noTranslate: { type: Boolean, default: false },
      loading: { type: Boolean, default: false },
      noPadding: { type: Boolean, default: false },
      noHeaderPadding: { type: Boolean, default: false },
      isSmall: { type: Boolean, default: false },
    },
    methods: { tr },
  }
</script>

<style scoped></style>
